






























































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Container from '@/components/Container.vue';
import { adminApi } from '@/api/admin.api';
import { Route } from 'vue-router';
import BaseTable from '@/components/BaseTable.vue';
import SortableTableHeader from '@/components/SortableTableHeader.vue';
import TableActionDropdown from '@/components/TableActionDropdown.vue';
import { Action, State } from 'vuex-class';
import {
  DeleteExceptionsPayload,
  InstanceModuleWithExceptions,
  ResourceTypes,
  RoleRows
} from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import {
  DeleteUsersFromRoleQueryParams,
  ResourcesRolesAndExceptionsInstances
} from '@/store/modules/role/types/role.types';
import {
  ModuleExceptionTypes,
  ResourceModuleWithExceptions,
  Role
} from '@/store/modules/roles-and-permissions/types/roles-and-permissions.types';
import { Group } from '@/store/modules/admin/types/admin.types';
import { User } from '@/store/modules/subscription/subscription.state';
import {
  EntityTypes,
  ModuleActionTypes
} from '@/store/modules/module-tree/enums/module-tree.enums';
import { RootState } from '@/store/store';
import CreateExceptionsModal from './CreateExceptionsModal.vue';
import { ToastProgrammatic as Toast } from 'buefy';
import { ApiState } from '@/store/types/general.types';
import ManageExceptionsModal from './ManageExceptionsModal.vue';
import AssignToRoleModal from './AssignToRoleModal.vue';
import { Job } from 'bull';
import { handleResolvePermissions } from '@/utils/update-resolve-permission-util';

@Component({
  components: { Container, BaseTable, SortableTableHeader, TableActionDropdown }
})
export default class ViewUserRolesAndExceptions extends Vue {
  userName: string = '';
  userEmail: string = '';
  resourceId: number | null = null;

  private isRemoveUserModalActive = false;
  private roleInfoToRemove: { roleId: number | null; roleName: string } = {
    roleId: null,
    roleName: ''
  };

  @Action('role/getResourcesRolesAndExceptionsInstances')
  private getResourcesRolesAndExceptionsInstances!: (payload: {
    resourceId: number;
    resourceType: ResourceTypes;
  }) => Promise<void>;

  @Action('role/deleteUsersFromRole')
  private deleteUsersFromRole!: (
    payload: DeleteUsersFromRoleQueryParams
  ) => Promise<Job[] | void>;

  @Action('rolesAndPermissions/deleteException')
  public deleteException!: (
    payload: DeleteExceptionsPayload
  ) => Promise<Job[] | void>;

  @Action('rolesAndPermissions/getResourceExceptionsByModule')
  public getResourceExceptionsByModule!: (payload: {
    moduleName: string;
    resourceId: string;
  }) => Promise<void>;

  @Action('rolesAndPermissions/getResourceExceptionsByModule')
  public getInstanceResourceExceptionsByModule!: (payload: {
    moduleName: string;
    resourceId: string;
    instanceId: number;
    instanceType: EntityTypes;
  }) => Promise<void>;

  @Action('rolesAndPermissions/finishJobs')
  public finishJobsAction!: (jobState: boolean) => Promise<void>;

  @State(({ role }: RootState) => role.resourcesRolesAndExceptionsInstances)
  private usersRolesAndExceptionsInstances!:
    | ResourcesRolesAndExceptionsInstances
    | undefined;

  @State(({ role }: RootState) => role.apiState.deleteUsersFromRole.success)
  private deleteUsersFromRoleSuccessState!: boolean;

  @State(
    ({ rolesAndPermissions }: RootState) =>
      rolesAndPermissions.apiState.deleteExceptions
  )
  public deleteExceptionState!: ApiState;

  @State(
    ({ rolesAndPermissions }: RootState) => rolesAndPermissions.finishedJobs
  )
  private jobsFinished!: boolean;

  get breadcrumbs() {
    // Link back to Roles & Permissions page with Users tab selected
    const usersTabRoute: Partial<Route> = {
      path: '/admin/roles-and-permissions',
      query: { tab: 'Users' }
    };

    return [
      { text: 'Users', route: usersTabRoute },
      { text: this.userName || '...' }
    ];
  }

  get userDisplayName() {
    if (this.userName && this.userEmail) {
      return `${this.userName} - ${this.userEmail}`;
    }
    return this.userName || this.userEmail || 'Loading...';
  }

  async created() {
    const idParam = this.$route.params.user_id;
    this.resourceId = Number(idParam);
    if (!Number.isNaN(this.resourceId)) {
      try {
        const { data } = await adminApi.getUserByAdmin(this.resourceId);
        // Adjust field names if different in response
        this.userName =
          [data?.firstName, data?.lastName].filter(Boolean).join(' ') ||
          data?.username ||
          '';
        this.userEmail = data?.email || '';
        // fetch roles/exceptions instances for this user
        await this.getResourcesRolesAndExceptionsInstances({
          resourceId: this.resourceId,
          resourceType: ResourceTypes.USER
        });
      } catch {
        this.userName = '';
        this.userEmail = '';
      }
    }
  }

  get roleRows(): RoleRows[] {
    const roles = this.usersRolesAndExceptionsInstances?.roles ?? [];
    return roles
      .filter((role) => role.roleName != null)
      .map((role) => ({
        roleId: role.roleId,
        roleName: role.roleName,
        assignedVia: role.assignedVia
      }));
  }

  goToRole(roleId: number) {
    if (!roleId) {
      return;
    }
    this.$router.push(`/admin/roles/${roleId}`);
  }

  get ModuleExceptionTypes() {
    return ModuleExceptionTypes;
  }

  get exceptionRows() {
    const exceptions =
      this.usersRolesAndExceptionsInstances &&
      this.usersRolesAndExceptionsInstances.exceptions;
    if (!exceptions) {
      return [];
    }

    const rows: Array<{
      label: string;
      instance: Group | null;
      resources: ResourceModuleWithExceptions[];
      assignedVia?: string | null;
    }> = [];

    if (exceptions.resources) {
      exceptions.resources.forEach((resource: ResourceModuleWithExceptions) => {
        rows.push({
          label: resource.label || '-',
          instance: null,
          resources: [resource],
          assignedVia: this.checkAssignedVia([resource])
        });
      });
    }

    if (exceptions.instances) {
      exceptions.instances.forEach((inst: InstanceModuleWithExceptions) => {
        const label =
          inst.instanceResources && inst.instanceResources.length > 0
            ? inst.instanceResources[0].label
            : '-';
        rows.push({
          label: label || '-',
          instance: inst.instance || null,
          resources: inst.instanceResources || [],
          assignedVia: this.checkAssignedVia(inst.instanceResources)
        });
      });
    }

    return rows;
  }

  async refresh() {
    if (this.resourceId) {
      await this.getResourcesRolesAndExceptionsInstances({
        resourceId: this.resourceId,
        resourceType: ResourceTypes.USER
      });
      this.finishJobsAction(false);
    }
  }

  private assignToRole(): void {
    this.$buefy.modal.open({
      parent: this,
      component: AssignToRoleModal,
      hasModalCard: true,
      trapFocus: true,
      props: {
        role: null,
        resourceType: ResourceTypes.USER,
        selectedUser: {
          userId: Number(this.$route.params.user_id),
          firstName: this.userName,
          lastName: '',
          email: this.userEmail
        }
      },
      events: {
        roleUpdated: async (jobs: Job[]) => {
          if (jobs) {
            await handleResolvePermissions.call(this, jobs[0]);
          }
        }
      }
    });
  }

  private openCreateNewExceptionModal(): void {
    this.$buefy.modal.open({
      parent: this,
      component: CreateExceptionsModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: true,
      props: {
        modalResourceType: ResourceTypes.USER,
        resourceUser: {
          userId: Number(this.$route.params.user_id),
          firstName: this.userName,
          email: this.userEmail
        }
      },
      events: {
        close: async (job: Job[]) => {
          if (job) {
            await handleResolvePermissions.call(this, job[0]);
          }
        }
      }
    });
  }

  checkAssignedVia(resources: Role[]): string | null {
    for (const resource of resources) {
      if (resource.assignedVia) {
        return resource.assignedVia;
      } else {
        const moduleWithAssignedVia = this.checkAssignedVia(
          resource.submodules
        );
        if (moduleWithAssignedVia) {
          return moduleWithAssignedVia;
        }
      }
    }
    return null;
  }

  public getResourceName(
    item: ResourceModuleWithExceptions,
    type: ResourceTypes
  ): string | null {
    switch (type) {
      case ResourceTypes.USER:
        const user: User = item.resource as User;
        return user.userProfile
          ? `${user.userProfile.firstName} ${user.userProfile.lastName}`
          : '';
      case ResourceTypes.GROUP:
        const group = item.resource as Group;
        return group && group.name
          ? group.types
            ? `${group.name}(${group.types.name})`
            : group.name
          : '';
      default:
        return null;
    }
  }

  public getResourceModules(
    resource: ResourceModuleWithExceptions,
    exceptionType: ModuleExceptionTypes
  ) {
    const module: Array<{
      tag: string;
      tagType: ModuleExceptionTypes;
      module: Role;
    }> = [];

    if (
      resource.exception === exceptionType &&
      resource.action === ModuleActionTypes.ALL
    ) {
      module.push({
        tag: 'All permissions',
        tagType: resource.exception,
        module: resource
      });
    } else {
      const resourceLabel = resource.label
        ? resource.level === 1
          ? resource.label
          : resource.label.split(' ')[0]
        : '';
      if (
        !resource.submodules.length &&
        resource.exception === exceptionType &&
        resourceLabel
      ) {
        module.push({
          tag: resourceLabel,
          tagType: resource.exception,
          module: resource
        });
      } else {
        resource.submodules.forEach((subModule) => {
          const subModuleLabel =
            subModule && subModule.label
              ? subModule.level === 1
                ? subModule.label
                : subModule.label.split(' ')[0]
              : '';

          if (
            subModule &&
            (subModule.exception === exceptionType ||
              subModule.exception === ModuleExceptionTypes.MIXED)
          ) {
            module.push({
              tag: subModuleLabel,
              tagType: subModule.exception,
              module: subModule
            });
          }
        });
      }
    }
    return module;
  }

  showTooltip(item: ResourceModuleWithExceptions): boolean {
    // Exclude the current item but match by label
    const otherRows = this.exceptionRows.filter(
      (r) => r.label === item.label && r.resources[0] !== item
    );
    const currentAllow =
      this.getResourceModules(item, ModuleExceptionTypes.ALLOW) || [];

    const currentAllowTags = currentAllow.map((m) => m.tag);
    // Get deny tags for current item
    const currentDeny =
      this.getResourceModules(item, ModuleExceptionTypes.DENY) || [];
    const currentDenyTags = currentDeny.map((m) => m.tag);

    // Track conflicts with other rows
    for (const row of otherRows) {
      const allowModules =
        this.getResourceModules(row.resources[0], ModuleExceptionTypes.ALLOW) ||
        [];
      const allowTags = allowModules.map((m) => m.tag);
      const hasAllPermissionsOther = allowTags.includes('All permissions');

      // Case: other row allows all but current denies anything
      if (hasAllPermissionsOther && currentDenyTags.length > 0) {
        return true;
      }

      const overlapAllowDeny = allowTags.some((tag) =>
        currentDenyTags.includes(tag)
      );

      if (overlapAllowDeny) {
        return true;
      }
    }

    // No conflicts found
    return false;
  }

  public handleManageExceptions(
    resource: ResourceModuleWithExceptions,
    instance: ResourceModuleWithExceptions
  ): void {
    if (instance) {
      this.getInstanceResourceExceptionsByModule({
        moduleName: resource.moduleName,
        resourceId: '' + resource.resource.id,
        instanceId: instance.id,
        instanceType: EntityTypes.GROUP
      });
    } else {
      this.getResourceExceptionsByModule({
        moduleName: resource.moduleName,
        resourceId: '' + resource.resource.id
      });
    }
    this.$buefy.modal.open({
      parent: this,
      component: ManageExceptionsModal,
      hasModalCard: true,
      trapFocus: true,
      fullScreen: true,
      props: {
        module: resource,
        resourceId: resource,
        instanceId: instance ? { instance: instance } : ''
      },
      events: {
        close: async (jobs: Job[]) => {
          if (jobs) {
            await handleResolvePermissions.call(this, jobs[0]);
          }
        }
      }
    });
  }

  public handleDeleteExceptions(
    resource: ResourceModuleWithExceptions,
    instance: ResourceModuleWithExceptions
  ): void {
    let moduleName = resource.moduleName;
    if (instance) {
      const instanceId = `${EntityTypes.GROUP}_${instance.id}`;
      const rootModules: string[] = resource.moduleName.split('-').slice(0, 2);
      moduleName = resource.moduleName.replace(
        rootModules.join('-'),
        instanceId
      );
    }
    this.$buefy.dialog.confirm({
      message: `<p class="buefy-dialog-title">Delete exceptions</p><p class="buefy-dialog-content  mb-4">Are you sure you want to delete exceptions?</p>`,
      confirmText: 'Delete exceptions',
      onConfirm: async () => {
        const jobs = await this.deleteException({
          resourceId: '' + this.resourceId,
          module: moduleName
        });
        if (jobs) {
          await handleResolvePermissions.call(this, jobs[0]);
        }
      },
      canCancel: ['button'],
      cancelText: 'Cancel',
      onCancel: undefined
    });
  }

  private handleRemoveRole(role: RoleRows): void {
    this.roleInfoToRemove = role;
    this.isRemoveUserModalActive = true;
  }

  private async confirmRemoveUserFromRole(): Promise<void> {
    if (this.resourceId && this.roleInfoToRemove.roleId) {
      const jobs = await this.deleteUsersFromRole({
        id: this.roleInfoToRemove.roleId,
        userIds: [this.resourceId]
      });
      if (jobs) {
        await handleResolvePermissions.call(this, jobs[0]);
      }
    }
  }

  @Watch('deleteUsersFromRoleSuccessState')
  private async watchDeleteUsersFromRoleSuccessState() {
    if (this.deleteUsersFromRoleSuccessState) {
      Toast.open({
        message: 'User removed from role',
        type: 'is-success',
        position: 'is-top'
      });
      this.isRemoveUserModalActive = false;
      this.refresh();
    }
  }

  @Watch('deleteExceptionState')
  public async onDeleteExceptionState(state: ApiState): Promise<void> {
    if (state.success) {
      Toast.open({
        queue: true,
        position: 'is-top',
        message: `Exceptions deleted`,
        type: 'is-dark',
        duration: 5000
      });
    } else if (state.error) {
      Toast.open({
        queue: true,
        position: 'is-top',
        message: 'Something went wrong. Try again.',
        type: 'is-danger',
        duration: 5000
      });
      this.refresh();
    }
  }

  @Watch('jobsFinished')
  private async watchfinishedJobs() {
    if (this.jobsFinished) {
      this.refresh();
    }
  }
}
